import {
  CLOSE_GET_STARTED_SECTION,
  GET_LIST_OF_APPS,
  GET_PLAN_SPECIFICATION_DETAILS,
  SET_GET_STARTED_SECTION,
  SET_LIST_OF_APPS,
  SET_PLAN_SPECIFICATION_DETAILS,
  SET_TRANSACTION_LIMIT,
  UPDATE_ACTIVE_MANAGE_APP
} from "./actionTypes"

const initialState = {
  appsListDetails: { appsList: [], appListCount: 0, responseMessage: null, responseStatus: null, loading: false, appsMaxCount: null },
  planSpecificationDetails: { plan: {}, responseMessage: null, responseStatus: null, loading: false },
  activeManageApp: {},
  getStarted: {
    check: false,
    loading: false,
    responseMessage: null,
  },
  transactionLimit: {
    limitAboutToExceed: false

  }
}

const Home = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_OF_APPS:
      state = {
        ...state,
        appsListDetails: { ...state.appsListDetails, loading: true }
      }
      break
    case GET_PLAN_SPECIFICATION_DETAILS:
      state = {
        ...state,
        planSpecificationDetails: { ...state.planSpecificationDetails, loading: true }
      }
      break
    case SET_PLAN_SPECIFICATION_DETAILS:
      state = {
        ...state,
        planSpecificationDetails: {
          ...state.planSpecificationDetails,
          plan: action.payload?.response || {},
          responseStatus: action.payload?.responseStatus || null,
          responseMessage: action.payload?.responseMessage || null,
          loading: false
        }
      }
      break
    case SET_LIST_OF_APPS:
      state = {
        ...state,
        appsListDetails: {
          ...state.planSpecificationDetails,
          appsList: action.payload?.response?.list || [],
          responseStatus: action.payload?.responseStatus || null,
          responseMessage: action.payload?.responseMessage || null,
          appListCount: action.payload?.response?.count || 0,
          responseCode: action.payload?.responseCode ? true : false,
          appsMaxCount: action.payload?.response?.maxCnt || null,
          loading: false
        }
      }
      break
    case UPDATE_ACTIVE_MANAGE_APP:
      state = {
        ...state,
        activeManageApp: action.payload || {}
      }
      break
    case CLOSE_GET_STARTED_SECTION:
      state = {
        ...state,
        getStarted: {
          ...state.getStarted,
          loading: true
        }
      }
      break
    case SET_GET_STARTED_SECTION:
      state = {
        ...state,
        getStarted: {
          ...state.getStarted,
          loading: false,
          check: action.payload.check,
          responseMessage: action.payload.responseMessage ? action.payload.responseMessage : null
        }
      }
      break
    case SET_TRANSACTION_LIMIT:
      state = {
        ...state,
        transactionLimit: {
          limitAboutToExceed: action?.payload?.response?.reach,
          ...action.payload
        }
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Home
